import 'core-js'
import Vue from 'vue'
import App from './pages/App.vue'

import VeeValidate from 'vee-validate'

Vue.use(VeeValidate, { inject: false, errorBagName: 'errors' })
Vue.component('app', App)

// eslint-disable-next-line no-new
new Vue({
  el: '#app'
})



// WEBPACK FOOTER //
// ./src/main.js